var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { range } from 'ramda';
import Translate from '../../components/Translate';

var MessageFirst = 'action.pagination.first';
var MessagePrevious = 'action.pagination.previous';
var MessageNext = 'action.pagination.next';
var MessageLast = 'action.pagination.last';

var Pagination = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination(props) {
    _classCallCheck(this, Pagination);

    var _this = _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    _this.state = { pager: {} };
    return _this;
  }

  _createClass(Pagination, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.items && this.props.items.length) {
        this.setPage(this.props.initialPage);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.items !== prevProps.items) {
        this.setPage(this.props.persistStep ? this.state.pager.currentPage : this.props.initialPage);
      }
    }
  }, {
    key: 'setPage',
    value: function setPage(page) {
      var items = this.props.items;
      var pager = this.state.pager;

      if (page < 1 || page > pager.totalPages) {
        return;
      }

      pager = this.getPager(items.length, page, this.props.pageSize);

      var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

      this.setState({ pager: pager });

      this.props.onChangePage(pageOfItems);
    }
  }, {
    key: 'getPager',
    value: function getPager(totalItems, currentPage, pageSize) {
      currentPage = currentPage || 1;

      var totalPages = Math.ceil(totalItems / pageSize);

      var startPage = void 0,
          endPage = void 0;
      if (totalPages <= 10) {
        startPage = 1;
        endPage = totalPages;
      } else {
        if (currentPage <= 6) {
          startPage = 1;
          endPage = 10;
        } else if (currentPage + 4 >= totalPages) {
          startPage = totalPages - 9;
          endPage = totalPages;
        } else {
          startPage = currentPage - 5;
          endPage = currentPage + 4;
        }
      }

      var startIndex = (currentPage - 1) * pageSize;
      var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
      var pages = range(startPage, endPage + 1);

      return {
        totalItems: totalItems,
        currentPage: currentPage,
        pageSize: pageSize,
        totalPages: totalPages,
        startPage: startPage,
        endPage: endPage,
        startIndex: startIndex,
        endIndex: endIndex,
        pages: pages
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var pager = this.state.pager;

      if (!pager.pages || pager.pages.length <= 1) {
        return null;
      }

      return React.createElement(
        'ul',
        { className: 'pagination' },
        React.createElement(
          'li',
          { className: pager.currentPage === 1 ? 'disabled' : '' },
          React.createElement(
            'a',
            { onClick: function onClick() {
                return _this2.setPage(1);
              } },
            React.createElement(Translate, { id: MessageFirst, defaultMessage: 'First' })
          )
        ),
        React.createElement(
          'li',
          { className: pager.currentPage === 1 ? 'disabled' : '' },
          React.createElement(
            'a',
            { onClick: function onClick() {
                return _this2.setPage(pager.currentPage - 1);
              } },
            React.createElement(Translate, { id: MessagePrevious, defaultMessage: 'Previous' })
          )
        ),
        this.props.isPageVisible && pager.pages.map(function (page, index) {
          return React.createElement(
            'li',
            {
              key: index,
              className: pager.currentPage === page ? 'active' : '' },
            React.createElement(
              'a',
              { onClick: function onClick() {
                  return _this2.setPage(page);
                } },
              page
            )
          );
        }),
        React.createElement(
          'li',
          {
            className: pager.currentPage === pager.totalPages ? 'disabled' : '' },
          React.createElement(
            'a',
            { onClick: function onClick() {
                return _this2.setPage(pager.currentPage + 1);
              } },
            React.createElement(Translate, { id: MessageNext, defaultMessage: 'Next' })
          )
        ),
        React.createElement(
          'li',
          {
            className: pager.currentPage === pager.totalPages ? 'disabled' : '' },
          React.createElement(
            'a',
            { onClick: function onClick() {
                return _this2.setPage(pager.totalPages);
              } },
            React.createElement(Translate, { id: MessageLast, defaultMessage: 'Last' })
          )
        )
      );
    }
  }]);

  return Pagination;
}(Component);

Pagination.propTypes = {
  items: PropTypes.array.isRequired,
  onChangePage: PropTypes.func.isRequired,
  initialPage: PropTypes.number,
  pageSize: PropTypes.number,
  isPageVisible: PropTypes.bool,
  persistStep: PropTypes.bool
};
Pagination.defaultProps = {
  initialPage: 1,
  pageSize: 10,
  isPageVisible: true
};

export default Pagination;